import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-custom-checkbox',
  templateUrl: './custom-checkbox.component.html',
  styleUrls: ['./custom-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CustomCheckboxComponent,
    },
  ],
})
export class CustomCheckboxComponent implements ControlValueAccessor {
  @Input()
  checked = false;

  @Output()
  changed = new EventEmitter<boolean>();

  touched = false;
  @Input() disabled = false;

  onChange: (value: boolean) => void = () => {};

  onTouched = () => {};

  onCheck() {
    this.markAsTouched();
    if (!this.disabled) {
      this.checked = !this.checked;
      this.changed.emit(this.checked);
      this.onChange(this.checked);
    }
  }

  writeValue(checked: boolean) {
    this.checked = checked;
  }

  registerOnChange(onChange: (value: boolean) => void) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }
}
